export const translatedAnswers: Record<string, Record<string, string>> = {
    area_c: {
        'E-handel': 'ehandel',
        Bank: 'bank',
        'Elektronisk kommunikation': 'electric',
    },
    category_c: {
        Webbsida: 'website',
        App: 'app',
    },
    service_or_product_c: {
        Tjänst: 'service',
        Produkt: 'product',
    },
    type_of_store_c: {
        'Fysisk butik': 'physic',
        'E-handel': 'ehandel',
    },
    informant_c: {
        Privatperson: 'private',
        Företag: 'company',
        Organisation: 'organisation',
    },
    category_product_c: {
        Dator: 'computer',
        Mobiltelefon: 'cellphone',
        Surfplatta: 'tablet',
        Läsplatta: 'reading_tablet',
        'Annan utrustning för att komma åt kommunikationstjänster': 'other_comm',
        'Annan utrustning för att komma åt medietjänster': 'other_media',
        Betalterminal: 'aetm',
        Automat: 'automat',
        'Interaktiv självbetjäningsterminal': 'interactive_self_service_terminal',
    },
}
export const specialMappedQuestions = new Set([
    'accessibility_issues_c',
    'navigation_issues_c',
    'language_clarity_c',
    'information_accessibility_c',
    'support_accessibility_c',
    'information_product_c',
    'packaging_instructions_c',
    'alternative_accessibility_c',
    'instructions_poor_c',
])
